import { LinkWidget } from "../../../clay/widgets/link-widget";

export const AiDisciplineLinkWidget = LinkWidget({
    table: "AiDiscipline",
    nameColumn: "name",
});
